import {
  Container,
  ContainerOptions,
  fontStringFromTextStyle,
  getFontFamilyName,
  Sprite,
  Text,
} from "pixi.js";
import { JackpotHitData } from "../models/JackpotHitData";
import GlobalStore from "../services/GlobalStore";

export class MarqueeJpHistoryItem extends Container {
  private data: JackpotHitData;
  private dateText: Text;
  private timeText: Text;
  private locationText: Text;
  private machineIdText: Text;
  private valueText: Text;
  private textSpacing: number = 10;

  private showTime: boolean;

  constructor({
    jpHitData,
    showTime = false,
    containerOpts,
  }: {
    jpHitData: JackpotHitData;
    showTime?: boolean;
    containerOpts?: ContainerOptions;
  }) {
    super(containerOpts);
    this.showTime = showTime;
    this.data = jpHitData;

    const fontFamily: string = "Avenir Next Condensed Demi Bold"; // "Avenir Next Condensed Demi Bold";

    const baseStyle = {
      fontFamily: fontFamily,
      fontSize: 40,
      fill: 0xffffff,
      lineHeight: 35,
    };

    this.dateText = new Text({
      text: "",
      style: {
        ...baseStyle,
        fontSize: 30,
      },
    });
    this.dateText.y = 16;

    this.locationText = new Text({
      text: "",
      style: {
        ...baseStyle,
        fontSize: 50,
      },
    });

    this.valueText = new Text({
      text: "",
      style: {
        fontFamily: "Faustina Extrabold",
        fontSize: 50,
        fill: 0xf2e476,
        letterSpacing: 0,
      },
    });
    this.valueText.y = 2;

    this.timeText = new Text({
      text: "",
      style: {
        ...baseStyle,
        fontSize: 20,
      },
    });
    this.timeText.y = 53;

    this.machineIdText = new Text({
      text: "",
      style: {
        ...baseStyle,
        fontSize: 20,
      },
    });
    this.machineIdText.y = 53;

    this.updateData();

    this.addChild(this.dateText);
    this.addChild(this.locationText);
    this.addChild(this.valueText);
    this.addChild(this.timeText);
    this.addChild(this.machineIdText);

    // this.addChild(Sprite.from("_plonk_jackpot"));
    this.sortFields();
  }

  private sortFields = (): void => {
    this.dateText.x = 0;
    this.timeText.x = this.dateText.x + 2;
    this.locationText.x = this.dateText.width + this.textSpacing;
    this.machineIdText.x = this.locationText.x + 2;
    this.valueText.x =
      this.locationText.x + this.locationText.width + this.textSpacing;
  };

  private updateData = (): void => {
    const locale = GlobalStore.getDateLocale();
    this.dateText.text = this.data.timestamp.toLocaleDateString(locale);
    this.timeText.text = this.data.timestamp.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    this.locationText.text = this.data.location;
    if (this.data.machineId)
      this.machineIdText.text = `ID: ${this.data.machineId}`;

    this.valueText.text = GlobalStore.formatCurrency(this.data.value);
  };

  public setData = (data: Readonly<JackpotHitData>) => {
    this.data = data;
    this.sortFields();
    this.updateData();
  };
}
